import React from 'react';
import styled from 'styled-components';
import Subject from '../../Components/Subject';
import mainImg from '../../assets/img/product/swing/swingMainImg.jpeg';
import SpecSection from './productComponents/SpecSection';
import HeaderContents from './productComponents/HeaderContents';
import DividingPattern from './productComponents/DividingPattern';
import DividingDesc from './productComponents/DividingDesc';
import DividingImg from './productComponents/DividingImg';
import BottomRail from './productComponents/BottomRail';
import DesignDesc from './productComponents/DesignDesc';
import ProductQuility from './productComponents/ProductQuility';
import ProcessSection from './productComponents/ProcessSection';
import Neccessary from './productComponents/Neccessary';
import ProductHeader from './ProductHeader';
import { swingData, swingInfo } from './productData';

const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  @media (max-width: 1280px) {
    width: 100%;
    padding: 0 20px 50px 20px;
  }
`;

const Box = styled.div`
  width: 100%;
`;

const Row = styled.div`
  > img {
    width: 100%;
  }
`;

const Swing = () => {
  return (
    <>
      <ProductHeader />
      <Container>
        <Subject info={swingInfo} />
        <Box>
          <Row>
            <img src={mainImg} alt="mainImg" />
          </Row>
          <HeaderContents info={swingInfo} />
          <DividingPattern info={swingInfo} />
          <DividingDesc
            title={swingInfo.dividingTitle}
            data={swingInfo.dividingDesc}
          />
          <DividingImg info={swingInfo.dividingBarImgs} />
          <BottomRail info={swingInfo} />
          <DesignDesc
            title={swingInfo.designTitle}
            data={swingInfo.designDesc}
          />
          {swingData.map((data, index) => (
            <SpecSection data={data} key={index} />
          ))}
          <ProcessSection />
          <Neccessary />
          <ProductQuility imgs={swingInfo.bottomImgs} />
        </Box>
      </Container>
    </>
  );
};

export default Swing;
